import { Application, EventEmitter, Text } from "pixi.js";
import { ConfigParams } from "./GameConfig";
import Keyboard from "./services/Keyboard";
import i18next from "i18next";
import { SceneManager } from "./scenes/SceneManager";
import SceneCurrentJackpot from "./scenes/SceneCurrentJackpot";
import SceneJackpotHit from "./scenes/SceneJackpotHit";
import SceneHistory from "./scenes/SceneHistory";
import GlobalStore from "./services/GlobalStore";
import SignController from "./services/SignController";

const Main = async (app: Application, config: ConfigParams) => {
  const eventEmitter = new EventEmitter();
  let masterVolume = config.app.initialVolume;

  let muted: boolean = config.app.muted;

  {
    // const langs = ["en-US", "es-ES"];
    // // keyboard
    // const keyCurrentJackpot = Keyboard("c");
    // const keyShowResults = Keyboard("r");
    // const keyNewHit = Keyboard("n");
    // const keyMute = Keyboard("m");
    // const keyNextLanguage = Keyboard("ArrowRight");
    // const keyVolumeUp = Keyboard("ArrowUp");
    // const keyVolumeDown = Keyboard("ArrowDown");
    // const keySendMessageToSocket = Keyboard(" ");
    // keyMute.press = () => {
    //   muted = !muted;
    // };
    // keyNewHit.press = () => {
    //   sm.playHitScene();
    // };
    // keyCurrentJackpot.press = () => {
    //   sm.switchScene("CurrentJackpot");
    // };
    // keyShowResults.press = () => {
    //   sm.switchScene("JackpotHistory");
    // };
    // keyNextLanguage.press = () => {
    //   console.log(i18next.language);
    //   const newLang =
    //     langs[(langs.indexOf(i18next.language) + 1) % langs.length];
    //   i18next.changeLanguage(newLang, () => {
    //     GlobalStore.setLanguage(newLang);
    //   });
    // };
    // keyVolumeUp.press = () => {
    //   masterVolume = Math.min(1, masterVolume + 0.1);
    // };
    // keyVolumeDown.press = () => {
    //   masterVolume = Math.max(0, masterVolume - 0.1);
    // };
    // keySendMessageToSocket.press = () => {
    //   // websocketSendText(socket, {
    //   //   type: "message",
    //   //   text: `Test message ${Math.random() * 100}`,
    //   // });
    // };
  }

  // DEBUG TEXT
  const debugText = new Text({
    text: "",
    style: {
      fontFamily: "Avenir Next Condensed Demi Bold",
      fontSize: 20,
      fill: 0xffffff,
      // align: "center",
      wordWrap: true,
      wordWrapWidth: 1000,
    },
  });
  debugText.x = 30;
  debugText.y = 30;

  debugText.zIndex = 10000;
  app.stage.addChild(debugText);

  // const testAnimation = new ImageAnimation({
  //   options: {
  //     path: "assets/animations/test",
  //     debugInfo: true,
  //     imageName: "test",
  //     frameCount: 90,
  //     // loop: false,
  //   },
  //   // containerOptions: {
  //   // boundsArea: new Rectangle(0, 0, 100, 100),
  //   // }
  // });
  // testAnimation.play();
  // testAnimation.zIndex = 99999;
  // app.stage.addChild(testAnimation);

  app.ticker.add((delta) => {
    let txt = `FPS: ${Math.round(app.ticker.FPS)}`;

    // txt += `\nCurrent scene: ${sm.getCurrentSceneName()}`;

    // txt += `\nDelta: ${delta.deltaMS.toFixed(2)}`;
    // if (videoHit) {
    //     txt += `\nHit: ${videoHit.paused ? "Paused" : "Playing"}`;
    //     txt += ` - ${(videoHit.progress * 100).toFixed(2)}%`;
    // }
    // txt += `\nHistory: ${videoHistory.paused ? "Paused" : "Playing"}`;
    // txt += ` - ${(videoHistory.progress * 100).toFixed(2)}%`;
    // txt += `\nCurrent values: ${videoShowCurrent.paused ? "Paused" : "Playing"}`;
    // txt += ` - ${(videoShowCurrent.progress * 100).toFixed(2)}%`;
    // txt += `\nMuted: ${muted}`;
    // txt += ` - Volume: ${(masterVolume * 100).toFixed(0)}%`;

    debugText.text = txt;
  });
};

export default Main;
